/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

import "@assets/scss/pages/authentication.scss";
import "./game.scss";
import {connect} from "react-redux";
import {history} from "@src/history";
import {getNftList} from '@store/actions/nft/nft_actions';
import handleNavigation from '@utils/handleNavigation';
import {toast} from "react-toastify";
import momentTimeToCountdown from '@utils/momentTimeToCountdown';


class Game extends React.Component {
        state = {
            sidebarOpen: false,
            season_start:"2023-12-10 18:00:00",
            event_ends:"2024-01-21 18:00:00",
            timerC:false
        }
    
    componentDidMount(prevProps) {
        this.startTimer()
    }

    componentDidUpdate(prevProps) {
    }
    componentWillUnmount(){
        
        clearInterval(this.timer)
    }
    scrollLeft = (e) => {
        document.getElementById('container').scrollLeft -= 310;
    }
    scrollRight = (e) => {
        document.getElementById('container').scrollLeft += 310;
    }
    createRefLink=() => {
        let refering_wallet = this.props.socket_user.wax_wallet;
        let ref_link = "https://game.nftbattleminers.com/profile?"+refering_wallet;
        navigator.clipboard.writeText(ref_link)
        toast.success('Link copied to clipboard')
    }
    countDown = () =>{
        if(window.location.pathname == '/'){
            this.setState({
                timerC:!this.state.timerC
            })
        }else{
            clearInterval(this.timer);
        }
    }
    startTimer = () =>{
        this.timer = setInterval(this.countDown, 1000);
    }

    render() {
        return (
        <>
                <div className="btn-events">
                    <div className="btn-evetn">
                        <span className="btn-event-text btn-event-hover">events</span>
                        <button type="button" className="new-btn btn-main btn-login invite-friend invite-friend-img " onClick={() => { history.push("/events") }}>
                        </button>
                    </div>
                    { this.props.user.userAccount && <div className="btn-evetn">
                        <span className="btn-event-text btn-event-hover">invite friends</span>
                        <button type="button" className="new-btn btn-main btn-login invite-friend invite-friend-background" onClick={this.createRefLink}></button>
                    </div>}
                    </div>

            <div className="page page-game">
                <div className="container-fluid">
                    <div className={!this.props.user.userAccount ? "header-main invite-friend-off":"header-main invite-friend-on"}>Welcome to NFT Battle Miners!</div>
                    <div id="container" className="key-box container container-position">
                    <button id="slideLeft" onClick={this.scrollLeft} className="scroll_button_left" style={{marginTop:'220px'}}></button>
                    <button id="slideRight" onClick={this.scrollRight} className="scroll_button_right" style={{marginTop:'220px',right:'0'}}></button>
                    <a href="https://neftyblocks.com/collection/battleminers/drops/207757+207759" target="_blank"
                            className="key-box key-box-banner">
                        <div className="banner-wrapper-timer">
                        <p className="banner-title-timer">SEASON START: MID DECEMBER</p>
                        <p className="banner-timer">OFFICIAL DATE YET TO COME{false && momentTimeToCountdown(this.state.season_start,null,"banner")}</p>
                    </div>           
                     </a>
                    <a href="https://nft-battle-miners.medium.com/alcor-nbm-farms-astonishing-facts-83c21095973d" target="_blank"
                            className="key-box key-box-banner-sale">
                        <div className="banner-wrapper-timer">
                         <p className="banner-title-timer"> Event ends in:</p>
                         <p className="banner-timer">{momentTimeToCountdown(this.state.event_ends,null,"banner")}</p>
                        </div>
                     </a>
                    <a href="#" onClick={e => handleNavigation(e, "/market")}
                            className="key-box key-box-market">
                            <div>
                                <h2>Marketplace</h2>
                                <h3><span>Browse and buy all the NFTs you need to play NBM. Lands, packs...</span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/mining")}
                        className="key-box key-box-mining">
                            <div>
                                <h2>Mining</h2>
                                <h3><span>Put your cards to work!</span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/cards")}
                            className="key-box key-box-cards">
                            <div>
                                <h2>My Cards</h2>
                                <h3><span>Check on your current portfolio in one place!</span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/mining_grid")}
                        className="key-box key-box-mini-game">
                            <div>
                                <h2>Mining Grid</h2>
                                <h3><span>Explore the Apertian region of New Terra. Mine resources and NFTs!</span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/library")}
                        className="key-box key-box-library">
                            <div>
                                <h2>Library</h2>
                                <h3><span>Explore the NBM NFT library! Dive deep into exploring Active cards...</span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/packs")}
                        className="key-box key-box-packs">
                            <div>
                                <h2>Pack Opening</h2>
                                <h3><span>The place to be for unpacking your packs!</span></h3>
                            </div>
                        </a>
                        
                        <a href="#" onClick={e => handleNavigation(e, "/blending")}
                        className="key-box key-box-blending">
                            <div>
                                <h2>Blending</h2>
                                <h3><span>Explore the selection of available blending recipes and enjoy...</span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/wallet")}
                        className="key-box key-box-wallet">
                            <div>
                                <h2>Wallet</h2>
                                <h3><span>Your personal in-game wallet!</span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/shop")}
                        className="key-box key-box-shop">
                            <div>
                                <h2>NBM Shop</h2>
                                <h3><span>Shopping time! Use your shop tickets and get the right to buy NBM assets!</span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/partners_pool")}
                        className="key-box key-box-partners-pool">
                            <div>
                                <h2>Partnership Pool</h2>
                                <h3><span>Participants of the NBM Partnership pool program!</span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/boosting_assets")}
                            className="key-box key-box-partners-boosters">
                            <div>
                                <h2>Boosters</h2>
                                <h3><span>Preview of all assets that can provide a boost for your mining operations!</span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/leaderboard")}
                            className="key-box key-box-lp_leaderboard">
                            <div>
                                <h2>Leaderboard</h2>
                                <h3><span>Various leaderboards displayed in one place!<br/></span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/lucky_draw")}
                        className="key-box key-box-lottery">
                            <div>
                                <h2>Lucky Draw</h2>
                                <h3><span>Participate in Lucky Draws and win awesome prizes!</span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/auctions")}
                            className="key-box key-box-auction">
                            <div>
                                <h2>Auctions</h2>
                                <h3><span>Cast your vote on future game direction/features!</span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/sales")}
                        className="key-box key-box-sales">
                            <div>
                                <h2>Sales</h2>
                                <h3><span>Sales and all the related details!</span></h3>
                            </div>
                        </a>
                        
                        {/* <a href="#" onClick={e => handleNavigation(e, "/burn")}
                        className="key-box key-box-burn">
                            <div>
                                <h2>Burn Stickers</h2>
                                <h3><span>Burn our stickers to earn!</span></h3>
                            </div>
                        </a> */}
                        <a href="#" onClick={e => handleNavigation(e, "/asset_search")}
                            className="key-box key-box-asset-search">
                            <div>
                                <h2>Asset Search</h2>
                                <h3><span>Find information on any NBM asset!</span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/mining_operation_search")}
                            className="key-box key-box-mining-op-search">
                            <div>
                                <h2>Mining Op Search</h2>
                                <h3><span>Find information on any NBM mining operation!</span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/votings")}
                            className="key-box key-box-default">
                            <div>
                                <h2>Voting</h2>
                                <h3><span>Cast your vote on future game direction/features!</span></h3>
                            </div>
                        </a>
                        <a href="#" onClick={e => handleNavigation(e, "/profile")}
                        className="key-box key-box-profile">
                            <div>
                                <h2>Profile</h2>
                                <h3><span>Change the settings of your profile here!</span></h3>
                            </div>
                        </a>
                        <a href="https://nftbattleminers.com/" target="_blank"
                        className="key-box key-box-website">
                            <div>
                                <h2>Website</h2>
                                <h3><span>NFT Battle Miners Website!</span></h3>
                            </div>
                        </a>
                    </div>
                </div>           
            </div>           
            </>    
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.authorizedUser.user,
        nft_list: state.nft.nft_list,
        wax: state.authorizedUser.wax,
        socket: state.socket.socket,
        socket_user: state.socket.socket_user
    }
}
export default connect(mapStateToProps, {getNftList})(Game)
